import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal/LegalPage";
import { PrivacyPolicy } from "@/components/legal/LegalModal";

export const Route = createFileRoute("/en/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy policy — Sellavo" },
      { name: "description", content: "How Sellavo processes personal data and protects your rights." },
      { property: "og:title", content: "Privacy policy — Sellavo" },
      { property: "og:description", content: "How Sellavo processes personal data and protects your rights." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en/privacy" }],
  }),
  component: () => <LegalPage title="Privacy policy" intro="How Sellavo processes personal data and protects your rights."><PrivacyPolicy /></LegalPage>,
});
